export default __webpack_public_path__ + "static/media/blender-export.1d71661e.png";